import React from "react";
import { Layout, Modal, Popover } from "antd";
import { Link } from "react-router-dom";

import { toggleCollapsedSideNav, userSignOut, setCurrency } from "../../appRedux/actions";
import UserInfo from "../../components/UserInfo";
import Auxiliary from "util/Auxiliary";
import { NAV_STYLE_DRAWER, NAV_STYLE_FIXED, NAV_STYLE_MINI_SIDEBAR, TAB_SIZE } from "../../constants/ThemeSetting";
import { useDispatch, useSelector } from "react-redux";
import { CisUI } from "../../util/CISUI";
import UserProfile from "../Sidebar/UserProfile";
import Shortcuts from "../../components/Shortcuts";

const { Header } = Layout;

const Topbar = () => {
  const { navStyle } = useSelector(({ settings }) => settings);
  const navCollapsed = useSelector(({ common }) => common.navCollapsed);
  const width = useSelector(({ common }) => common.width);
  const currentCurrency = useSelector(({ common }) => common.currency);
  const dispatch = useDispatch();
  const Logo = "/assets/images/penterpv1.png";

  const currencyOptions = [
    { symbol: "₵", name: "Ghanaian Cedi (GHC)" },
    { symbol: "$", name: "US Dollar (USD)" },
    { symbol: "£", name: "Pound (GBP)" },
    { symbol: "€", name: "Euro (EUR)" },
    { symbol: "C$", name: "Canadian Dollar (CAD)" },
  ];

  const currencyMenu = (
    <div style={{ background: "#fff", borderRadius: 8, padding: "6px 0", boxShadow: "0 2px 8px rgba(0,0,0,0.15)", minWidth: 160 }}>
      {currencyOptions.map((c) => (
        <div
          key={c.symbol}
          onClick={() => dispatch(setCurrency(c.symbol))}
          style={{
            padding: "8px 16px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: 8,
            background: currentCurrency === c.symbol ? "#e6f7ff" : "transparent",
            color: currentCurrency === c.symbol ? "#1890ff" : "#333",
            fontWeight: currentCurrency === c.symbol ? 600 : 400,
            fontSize: 14,
          }}
          onMouseEnter={(e) => { if (currentCurrency !== c.symbol) e.target.style.background = "#f5f5f5"; }}
          onMouseLeave={(e) => { if (currentCurrency !== c.symbol) e.target.style.background = "transparent"; }}
        >
          <span style={{ fontSize: 16, width: 20 }}>{c.symbol}</span>
          <span>{c.name}</span>
        </div>
      ))}
    </div>
  );

  // const handleChange = (value) => {
  // }

  const showLogoutConfirm = () => {
    Modal.confirm({
      title: "Are you sure you want logout?",
      centered: true,
      onOk: () => dispatch(userSignOut()),
      okText: "Yes",
      cancelText: "No",
      // content: 'Bla bla ...',
      footer: (_, { OkBtn, CancelBtn }) => (
        <div style={{ textAlign: "center" }}>
          {/*<CancelBtn />*/}
          <OkBtn />
        </div>
      ),
    });
  };

  return (
    <div>
      <Header style={{ background: "#2F4E67" }}>
        {navStyle === NAV_STYLE_DRAWER ||
        ((navStyle === NAV_STYLE_FIXED || navStyle === NAV_STYLE_MINI_SIDEBAR) && width < TAB_SIZE) ? (
          <div className="gx-mr-3 gx-linebar">
            <i
              className="gx-icon-btn icon icon-menu"
              onClick={() => {
                dispatch(toggleCollapsedSideNav(!navCollapsed));
              }}
            />
          </div>
        ) : null}
        {width >= TAB_SIZE && (
          <Link to="/" className="gx-d-block gx-d-lg-none gx-pointer">
            <img alt="" src={Logo} style={{ width: "50px" }} />
          </Link>
        )}

        <div style={{ fontWeight: "bold", fontSize: "20px" }}>{CisUI().getUserInfo("companyName")}</div>

        <ul className="gx-ml-auto gx-header-notifications">
          {/*<li className="gx-d-inline-block gx-notify gx-notify-search gx-d-lg-none" style={{display: 'none !important'}}>*/}
          {/*    <Popover overlayClassName="gx-popover-horizantal" placement="bottomRight" content={*/}
          {/*        <SearchBox styleName="gx-popover-search-bar"*/}
          {/*                   placeholder="Search in app..."*/}
          {/*                   onChange={updateSearchChatUser}*/}
          {/*                   value={searchText}/>*/}
          {/*    } trigger="click">*/}
          {/*        <span className="gx-d-block gx-pointer" style={{color: 'white'}}><i*/}
          {/*            className="icon icon-search-new"/></span>*/}
          {/*    </Popover>*/}
          {/*</li>*/}

          {/*<li>*/}
          {/*    <a*/}
          {/*        href={"http://localhost:3001/emslogin?token=" + token}*/}
          {/*        title={"Support Portal"}*/}
          {/*        target="_blank"*/}
          {/*        rel="noopener noreferrer"*/}
          {/*    >*/}
          {/*        <HelpOutline style={{ fontSize: "30px" }} />*/}
          {/*    </a>*/}
          {/*</li>*/}

          {width >= TAB_SIZE && (
            <li style={{ display: "flex", gap: "10px", color: "white" }}>
              <a href="https://support.penterp.com/" target="_blank">
                <i
                  className="icon icon-sweet-alert"
                  style={{
                    position: "relative",
                    top: "3px",
                    margin: "0px 5px 0px 0px",
                    fontSize: "15px",
                    color: "white",
                  }}
                />
                <span className="support-title" style={{ fontSize: "15px", color: "white" }}>
                  Help
                </span>
              </a>
            </li>
          )}

          {/*<li className="gx-language">*/}
          {/*    <Popover overlayClassName="gx-popover-horizantal" placement="bottomRight"*/}
          {/*             content={languageMenu()}*/}
          {/*             trigger="click">*/}
          {/*                <span className="gx-flex-row gx-align-items-center gx-pointer">*/}
          {/*                  <i className={`flag flag-24 flag-${locale.icon}`}/>*/}
          {/*                  <span className="gx-pl-2 gx-language-name" style={{color: 'white'}}>{locale.name}</span>*/}
          {/*                  <i className="gx-pl-2 icon icon-chevron-down" style={{color: 'white'}}/>*/}
          {/*                </span>*/}
          {/*    </Popover>*/}
          {/*</li>*/}

          <Auxiliary>
            <li className="gx-user-nav">
              <UserProfile />
            </li>
          </Auxiliary>
        </ul>
      </Header>
      <div
        style={{
          height: "35px",
          color: "white",
          background: "#487091",
          padding: "0 32px",
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
        }}
        className="no-print"
      >
        <div style={{ display: "flex", columnGap: "18px", fontSize: "16px", marginTop: "6px" }}>
          {/*<div>*/}
          {/*    <i class='icon icon-avatar' style={{marginRight: '3px'}}></i>*/}
          {/*    <i className="icon icon-chevron-down"/>*/}
          {/*</div>*/}
          {/*<div>*/}
          {/*    <i class='icon icon-setting' style={{marginRight: '3px'}}></i>*/}
          {/*    <i className="icon icon-chevron-down"/>*/}
          {/*</div>*/}
          <div>
            {/*<span className="currency" style={{marginRight: '20px'}}>*/}
            {/*    <Popover overlayClassName="gx-popover-horizantal1" placement="bottomRight" content={<Shortcuts />} trigger="click">*/}
            {/*        <span className="gx-d-block gx-pointer gx-status-pos">*/}
            {/*          <i className="icon icon-apps icon__color"/> Favorites*/}
            {/*        </span>*/}
            {/*    </Popover>*/}
            {/*</span>*/}
            {/*<span className="currency" style={{marginRight: '20px'}}>₵</span>*/}
            {/*<span className="gx-language" onClick={() => dispatch(userSignOut())}>*/}
            {/*    <button type="button" className="ant-btn ant-btn-danger"*/}
            {/*            style={{height: '40px', marginTop: '10px'}}><span>Logout</span></button>*/}
            {/*</span>*/}

            <ul className="gx-ml-auto gx-header-notifications">
              <li className="gx-msg">
                <Popover
                  overlayClassName="gx-popover-horizantal"
                  placement="bottomRight"
                  content={<Shortcuts />}
                  trigger="click"
                >
                  <span className="gx-d-block gx-pointer gx-status-pos">
                    <i className="icon icon-apps icon__color" /> Favorites
                  </span>
                </Popover>
              </li>

              <li>
                <li>
                  <Link to={"/changelayout"}>
                    <i className="icon icon-callout" style={{ color: "white" }}></i>
                  </Link>
                </li>
              </li>
              <li className="currency">
                <Popover content={currencyMenu} trigger="click" placement="bottomRight">
                  <span style={{ cursor: "pointer", fontSize: 18, fontWeight: 600, color: "white" }}>
                    {currentCurrency}
                  </span>
                </Popover>
              </li>
              <li className="gx-language" onClick={showLogoutConfirm}>
                <button type="button" className="ant-btn ant-btn-danger" style={{ height: "40px", marginTop: "10px" }}>
                  <span>Logout</span>
                </button>
              </li>

              {width >= TAB_SIZE ? null : (
                <Auxiliary>
                  <li className="gx-user-nav">
                    <UserInfo />
                  </li>
                </Auxiliary>
              )}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Topbar;
